import { Cheetah, Ferrari812 } from "./Sprites";

const GOLD = "#D4AF37";
const IVORY = "#F5F5F5";

const Loop = ({ children }) =>
  [0, 1].map((k) => (
    <g key={k} transform={`translate(${k * 1200} 0)`}>
      {children}
    </g>
  ));

// Top third — a Ferrari 812 sweeping from right to left
export const TopBand = () => (
  <g>
    <rect width="1200" height="64" fill="#1E0E11" />
    <rect y="42" width="1200" height="22" fill="#161616" />
    <rect y="42" width="1200" height="1.5" fill={GOLD} opacity="0.7" />
    <g className="intro-road-left">
      {Array.from({ length: 20 }).map((_, i) => (
        <rect key={i} x={i * 80} y="52" width="40" height="2.5" fill={GOLD} opacity="0.4" />
      ))}
    </g>
    <g className="intro-drive-left">
      <Loop>
        {/* speed streaks trailing behind (right of) the hero car */}
        {[0, 1, 2].map((i) => (
          <rect key={i} x={318 + i * 20} y={24 + i * 6} width={28 - i * 6} height="1.6" fill={IVORY} opacity={0.5 - i * 0.13} />
        ))}
        <Ferrari812 x={250} y={18} scale={0.62} />
        <Ferrari812 x={760} y={22} scale={0.5} />
      </Loop>
    </g>
  </g>
);

const FedoraMan = ({ x = 0, y = 0, s = 1 }) => (
  <g transform={`translate(${x} ${y}) scale(${s})`}>
    <ellipse cx="13" cy="8" rx="16" ry="3.6" fill="#000" />
    <path d="M5 8 Q6 -1 13 -1 Q20 -1 21 8 Z" fill="#000" />
    <rect x="9" y="9" width="8" height="6" fill="#000" />
    <path d="M1 16 L25 16 L29 54 L-3 54 Z" fill="#000" />
  </g>
);

const VintageCar = ({ x = 0, y = 0, s = 1 }) => (
  <g transform={`translate(${x} ${y}) scale(${s})`}>
    <path d="M0 26 L7 13 L26 7 L58 6 L74 12 L96 18 L96 26 Z" fill="#000" />
    <path d="M30 9 L54 8 L66 13 L34 14 Z" fill="#1A1A1A" />
    <rect x="90" y="16" width="7" height="4" fill="#DADADA" opacity="0.85" />
    <circle cx="22" cy="27" r="7" fill="#000" />
    <circle cx="72" cy="27" r="7" fill="#000" />
    <circle cx="22" cy="27" r="2.6" fill="#555" />
    <circle cx="72" cy="27" r="2.6" fill="#555" />
  </g>
);

const StreetLamp = ({ x = 0, y = 0, s = 1 }) => (
  <g transform={`translate(${x} ${y}) scale(${s})`}>
    <rect x="6" y="8" width="3" height="50" fill="#000" />
    <path d="M7 9 Q7 2 16 2" fill="none" stroke="#000" strokeWidth="3" />
    <circle cx="16" cy="4" r="4.5" fill="#EDEDED" />
    <circle cx="16" cy="4" r="9" fill="#EDEDED" opacity="0.18" />
  </g>
);

// Middle third — a high-contrast film-noir MAFIA scene
export const MidBand = () => (
  <g>
    <defs>
      <linearGradient id="mafia-light" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#E6E6E6" />
        <stop offset="0.55" stopColor="#B4B4B4" />
        <stop offset="1" stopColor="#6E6E6E" />
      </linearGradient>
    </defs>
    <rect width="1200" height="64" fill="#0C0C0C" />
    {/* window light flooding the room */}
    <rect width="1200" height="64" fill="url(#mafia-light)" opacity="0.95" />
    {/* venetian blind slats */}
    <g>
      {Array.from({ length: 16 }).map((_, i) => (
        <rect key={i} y={2 + i * 3.4} width="1200" height="2.2" fill="#0C0C0C" opacity="0.6" />
      ))}
    </g>
    {/* floor */}
    <rect y="52" width="1200" height="12" fill="#3A3A3A" />
    <rect y="52" width="1200" height="1" fill="#E4E4E4" opacity="0.6" />
    {/* silhouettes slowly panning */}
    <g className="intro-pan">
      <Loop>
        <StreetLamp x={40} y={2} s={1} />
        <FedoraMan x={130} y={6} s={0.95} />
        <FedoraMan x={182} y={9} s={0.82} />
        <VintageCar x={330} y={24} s={1} />
        <FedoraMan x={560} y={5} s={1} />
        <StreetLamp x={690} y={2} s={1} />
        <FedoraMan x={800} y={8} s={0.9} />
        <VintageCar x={950} y={26} s={0.85} />
      </Loop>
    </g>
  </g>
);

// Bottom third — a cheetah sprinting from left to right
export const BotBand = () => (
  <g>
    <rect width="1200" height="64" fill="#241309" />
    <rect y="44" width="1200" height="20" fill="#38270F" />
    <rect y="44" width="1200" height="1.5" fill={GOLD} opacity="0.7" />
    <g className="intro-ground-left">
      {Array.from({ length: 40 }).map((_, i) => (
        <polyline key={i} points={`${i * 32},44 ${i * 32 + 3},37 ${i * 32 + 6},44`} fill="none" stroke={GOLD} strokeOpacity="0.55" strokeWidth="1.2" />
      ))}
    </g>
    <g className="intro-run-right">
      <Loop>
        {/* dust kicked up behind (left of) the runner */}
        {[0, 1, 2].map((i) => (
          <circle key={i} cx={208 - i * 12} cy={44 - i * 2} r={2.4 + i} fill="#6A4A28" opacity={0.6 - i * 0.16} />
        ))}
        <Cheetah x={220} y={4} scale={0.9} />
        <Cheetah x={760} y={12} scale={0.72} />
      </Loop>
    </g>
  </g>
);
